// src/services/codigoPagoService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'codigos-pago/';

// Interfaz para CodigoPagoConfig
export interface CodigoPagoConfig {
    id: number;
    nombre: string;
    prefijo: string;
    activo: boolean;
    fecha_creacion: string;
}

// Obtener todos los prefijos de pago
export const fetchCodigoPagoConfigs = async (): Promise<CodigoPagoConfig[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

// Crear un nuevo prefijo de pago
export const createCodigoPagoConfig = async (data: {
    nombre: string;
    prefijo: string;
    activo: boolean;
}): Promise<CodigoPagoConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// Actualizar un prefijo existente
export const updateCodigoPagoConfig = async (
    id: number,
    data: {
        nombre: string;
        prefijo: string;
        activo: boolean;
    }
): Promise<CodigoPagoConfig> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// Eliminar un prefijo
export const deleteCodigoPagoConfig = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};